import { PaginationItemType } from '../../enums';
const getPaginationItem = (position, totalPages, currentPage, getPageUrl) => {
    switch (position) {
        default:
        case 0: {
            return {
                type: PaginationItemType.ArrowLeft,
                ...getPageUrl(currentPage - 1 || 1, currentPage !== 1),
            };
        }
        case 1: {
            if (totalPages <= 4) {
                return {
                    type: PaginationItemType.Page,
                    page: 1,
                    ...getPageUrl(1, currentPage !== 1),
                };
            }
            if (currentPage > totalPages - 3) {
                return {
                    type: PaginationItemType.Page,
                    page: 1,
                    ...getPageUrl(1),
                };
            }
            return {
                type: PaginationItemType.Page,
                page: currentPage,
                ...getPageUrl(currentPage, false),
            };
        }
        case 2: {
            if (totalPages <= 3) {
                const targetPage = 2;
                return {
                    type: PaginationItemType.Page,
                    page: targetPage,
                    ...getPageUrl(targetPage, currentPage !== 2),
                };
            }
            if (currentPage === totalPages - 2) {
                return {
                    type: PaginationItemType.Page,
                    page: currentPage,
                    ...getPageUrl(currentPage, false),
                };
            }
            if (currentPage < totalPages - 1) {
                return {
                    type: PaginationItemType.Page,
                    page: currentPage + 1,
                    ...getPageUrl(currentPage + 1, currentPage !== totalPages - 1),
                };
            }
            return {
                type: PaginationItemType.Dots,
            };
        }
        case 3: {
            if (totalPages === 3) {
                return {
                    type: PaginationItemType.Page,
                    page: 3,
                    ...getPageUrl(3, currentPage !== 3),
                };
            }
            if (currentPage >= totalPages - 1) {
                return {
                    type: PaginationItemType.Page,
                    page: totalPages - 1,
                    ...getPageUrl(currentPage - 1, currentPage !== totalPages - 1),
                };
            }
            return {
                type: PaginationItemType.Dots,
            };
        }
        case 4:
            return {
                type: PaginationItemType.Page,
                page: totalPages,
                ...getPageUrl(totalPages, currentPage !== totalPages),
            };
        case 5:
            return {
                type: PaginationItemType.ArrowRight,
                ...getPageUrl(currentPage + 1 > totalPages ? totalPages : currentPage + 1, currentPage !== totalPages),
            };
    }
};
export const getPaginationItems = (totalPages, currentPage, getPageUrl) => [
    getPaginationItem(0, totalPages, currentPage, getPageUrl),
    totalPages >= 1 && getPaginationItem(1, totalPages, currentPage, getPageUrl),
    totalPages >= 2 && getPaginationItem(2, totalPages, currentPage, getPageUrl),
    totalPages >= 3 && getPaginationItem(3, totalPages, currentPage, getPageUrl),
    totalPages >= 4 && getPaginationItem(4, totalPages, currentPage, getPageUrl),
    getPaginationItem(5, totalPages, currentPage, getPageUrl),
].filter((item) => Boolean(item));
